import React from 'react';
import { get } from 'lodash';
import { Select } from 'antd';
import { limitOpions } from '../../constants/paginationLimit';

const ShowPaginationLimits = ({
  tableData,
  offset,
  limit,
  fetchTableData,
  filterChips,
}) => {
  return (
    <>
      <div>
        Showing {get(tableData, 'data').length ? offset + 1 : 0}-
        {get(tableData, 'pagination.total') < limit ||
        get(tableData, 'pagination.total') < offset + limit
          ? get(tableData, 'pagination.total')
          : offset + limit}{' '}
        of {get(tableData, 'pagination.total')} results
      </div>

      <div className="d-flex" style={{ gap: '9px' }}>
        <div>Results per page</div>
        <div>
          <Select
            value={get(tableData, 'pagination.limit')}
            onChange={(value) => {
              fetchTableData(
                get(tableData, 'pagination.current'),
                get(tableData, 'filters'),
                get(tableData, 'sorters'),
                filterChips,
                value
              );
            }}
            options={limitOpions}
          />
        </div>
      </div>
    </>
  );
};

export default ShowPaginationLimits;
